/**
 * This exception is thrown when a request is made with a hash that is itself invalid.
 */
export class InvalidHashException extends Error {}

/**
 * This exception is thrown when an attempt is made to invite a new representative once the limit is already reached.
 */
export class RepresentativeLimitReachedException extends Error {}

/**
 * This exception is thrown when an invalid serial is sent to the api when adding a equipment.
 */
export class SerialValidationException extends Error {}

/**
 * This exception is thrown when a request is made with the id of a equipment that does not exist in the database.
 */
export class EquipmentNotFoundException extends Error {}

/**
 * This exception is thrown when a request to create a user is made passing a website that is already registered.
 */
export class BusinessWebsiteAlreadyExistsException extends Error {}

/**
 * This exception is thrown when an attempt is made to create a new
 * representative with an email that has been already used to create another
 * representative.
 */
export class RepresentativeAlreadyExistsException extends Error {}
